import React from 'react';
import { GiHouse} from 'react-icons/gi';
import { FaMailBulk} from 'react-icons/fa';
import Detail from '../../components/pages/detail';
import FRComponent from './pages/typeb';
export default () => {
    return (
        <Detail 
            title={`telex`} 
            icon={FaMailBulk} 
            id={'typeb_parser'}
            url={`api/v1/bot`}
            breadcrumbs={
                [
                    {
                        href:'/home',
                        icon:<GiHouse color='white' />,
                        item:'home'
                    },
                    {
                        item:'bot'
                    },
                    {
                        item:'telex'
                    },
                ]
            }
            DetailComponent={FRComponent}
        />
    )
}